import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';
import { EntityRoutes, SharedRoutes } from '@shared/shared.routes';

export class AppRouterReuseStrategy extends BaseRouteReuseStrategy {

    override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return future.routeConfig?.path === SharedRoutes.dataReportRoute.name
         || (future.parent?.routeConfig?.path === SharedRoutes.entityRoute.name && future.routeConfig?.path === EntityRoutes.entityDataRoute.name)
         ? false : super.shouldReuseRoute(future, curr);
    }
}